import React from 'react'
import InfiniteCarasoul from '../InfiniteCarasoul'

const ContacUs = () => {
  return <h1>hello</h1>
}

export default ContacUs
